import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CA8CE1CF-1F6E-4B8B-9972-B3F36E865E67
 * name text-long
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-long.svg
 * tags
 */
export const TextLongIcon = createSvgIcon(<><path d="M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z" /></>, 'TextLongIcon');
export default TextLongIcon